import styled from '@emotion/styled';
import { Paper } from '@material-ui/core';
import { OrderEnum } from 'enums/orderEnum';
import { isInIFrame } from 'utils/services/kenticoSdk.service';

export const TranslationProgressDiv = styled.div`
  position: relative;
  flex-grow: 1;
  height: calc(100% - 122px);
  padding: ${isInIFrame ? '6px' : '16px'};
  overflow: auto;
`;

export const TranslationProgressHeaderCheckbox = styled.div<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  .MuiTypography-colorTextPrimary {
    ${({ disabled }) => (disabled ? 'color: rgba(0, 0, 0, 0.26) !important' : '')};
  }
`;

export const TableContainer = styled.div`
  width: 100%;
  padding-right: 6px;
  padding-bottom: 10px;
  overflow: auto;
  min-height: ${isInIFrame ? '300px' : 'initial'};
`;

export const TableHeaderRow = styled.div`
  position: sticky;
  top: 0;
  z-index: 3;
  padding: 0 5px;
  display: flex;
  background-color: #dce5ed;
  border-radius: 4px;
  justify-content: space-between;
`;

export const TableHeader = styled.div<{ sortable?: boolean; sortDirection?: OrderEnum; active?: boolean }>`
  display: flex;
  align-items: center;
  color: #6f8294;
  font-size: 15px;
  font-weight: 600;
  min-height: 28px;
  cursor: ${({ sortable }) => (sortable ? 'pointer' : 'inherit')};
  ${({ sortable }) => (sortable ? 'user-select: none;' : '')};

  &::after {
    margin: 0 2px;
    margin-left: 8px;
    content: '';
    display: ${({ sortable }) => (sortable ? 'block' : 'none')};
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid #00a4e4;
    opacity: ${({ active }) => Number(active)};
    transform: ${({ sortDirection }) => (sortDirection === OrderEnum.ASC ? 'rotate(0deg)' : 'rotate(180deg)')};
    transition: opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  }

  &:hover::after {
    opacity: ${({ sortable, active }) => (sortable && !active ? '0.6' : '1')};
  }
`;

export const TableRow = styled(Paper)<{ nest?: number }>`
  position: relative;
  display: flex;
  padding: 0 5px;
  margin: 8px 0;
  margin-top: ${({ nest }) => (nest === 0 ? '12px' : 0)};
  margin-left: ${({ nest }) => (nest ? `${nest * (isInIFrame ? 24 : 48)}px` : 0)};
  background-color: ${({ nest }) => (nest === 1 ? '#e5e5e5 !important' : '#fff !important')};
  box-shadow: ${({ nest }) => (nest === 1 ? 'none !important' : 'inherit')};
  justify-content: space-between;
  & span {
    color: #333 !important;
  }
`;

export const TableCell = styled.div<{ width?: number; nest?: number; shorter?: boolean }>`
  display: flex;
  align-items: center;
  width: ${({ width, nest, shorter }) => {
    const margin = isInIFrame ? 24 : 48;
    return width
      ? nest
        ? shorter
          ? `calc((100% - 230px + ${margin * nest}px) / ${100 / width} - ${margin * nest}px)`
          : `calc((100% - 230px + ${margin * nest}px) / ${100 / width})`
        : `calc((100% - 230px) / ${100 / width})`
      : 'auto';
  }};
`;

export const TranslationProgressTableSpinnerDiv = styled.div`
  display: flex;
  justify-content: center;
  padding: 40px 0;
`;

export const DataEmptyDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 31.5px 0;

  & > svg {
    font-size: 64px;
    color: #697686;
  }

  & > span {
    font-size: 18px;
  }
`;
